import { all } from 'redux-saga/effects';

import userProfile from './user-profile/sagas';
import callApi from './callApi/sagas';

export default function* rootSaga() {
  yield all([...callApi, ...userProfile]);
}
